export async function transformValgResultat(resultat) {
  resultat.type = 'valgresultat'
  if (resultat.resultatType === 'PrognoseOverstyring' && resultat.partier) {
    resultat.partier.forEach(parti => {
      parti.stemmer.antall = undefined
    })
  }
  return resultat
}

export async function transformPartiValgResultat(resultat) {
  resultat.type = 'partivalgresultat'
  return resultat
}

export function joinPartivalgResultat([resultat, nasjonaltResultat]) {
  if (nasjonaltResultat.steder && nasjonaltResultat.steder.length) {
    resultat.nasjonalt = nasjonaltResultat.steder[0]
  }
  return resultat
}
